// DS: B0
import React from 'react';
import classnames from 'classnames';
import s from './SubmitButton.scss';
export var SubmitButton = function (_a) {
    var id = _a.id, className = _a.className, isOpen = _a.isOpen, onClick = _a.onClick, children = _a.children, ariaControls = _a["aria-controls"];
    return (React.createElement("button", { id: id, className: classnames(s['root'], className), "aria-haspopup": true, "aria-expanded": isOpen, "aria-controls": ariaControls, onClick: onClick }, children));
};
SubmitButton.displayName = 'SubmitButton';
export default SubmitButton;
//# sourceMappingURL=SubmitButton.js.map